<div [class]="cssClass()">

	@if(layout.dimensions().breakpoint === 'wide-computer'){
	<ng-content select='mobile-panel-part.left-panel'></ng-content>
	}

	@if(touchService.emulating()) {
	<div class="emulated-touch-cursor" [style.transform]="cursorTransform()"></div>
	}

	<mobile-layout-part [restrictNavigation]="restrictNavigation()">
		<ng-content select='div.page-content'></ng-content>
		<div class="page-footer-from-frame">
			<ng-content select='div.page-footer-from-app'></ng-content>
		</div>
	</mobile-layout-part>


	@if(layout.dimensions().breakpoint === 'computer' || layout.dimensions().breakpoint === 'wide-computer'){
	<ng-content select='mobile-panel-part.right-panel'></ng-content>
	}

</div>